(function () {
  'use strict';

  if (window.__hatchillCartDrawerV2Tracking) return;
  window.__hatchillCartDrawerV2Tracking = true;

  var designVersion = 'quiet-retail-v2';

  function getCartState(drawer) {
    var countElement = drawer && drawer.querySelector('.cart-item-count');
    var checkoutButton = drawer && drawer.querySelector('#CartDrawer-Checkout');
    var itemCount = Number.parseInt(countElement && countElement.textContent, 10);
    var cartTotal = Number.parseInt(checkoutButton && checkoutButton.dataset.cartTotal, 10);

    return {
      surface: 'cart_drawer',
      design_version: designVersion,
      item_count: Number.isFinite(itemCount) ? itemCount : 0,
      cart_total: Number.isFinite(cartTotal) ? cartTotal : 0,
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : ''
    };
  }

  function publish(name, properties) {
    var payload = Object.assign({}, properties);

    try {
      if (window.HatchillEvents && typeof window.HatchillEvents.track === 'function') {
        window.HatchillEvents.track(name, payload);
      }
    } catch (error) {}

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var published = window.Shopify.analytics.publish('hatchill:' + name, payload);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    } catch (error) {}
  }

  document.addEventListener('cart-drawer:open', function (event) {
    var drawer = (event.detail && event.detail.drawer) || document.querySelector('cart-drawer');
    if (!drawer || !drawer.querySelector('#CartDrawer.hatchill-cart-v2')) return;

    publish('cart_drawer_viewed', getCartState(drawer));
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var checkoutButton = event.target.closest('#CartDrawer.hatchill-cart-v2 #CartDrawer-Checkout');

    if (checkoutButton) {
      publish('cart_drawer_checkout_clicked', getCartState(checkoutButton.closest('cart-drawer')));
      return;
    }

    var progressSummary = event.target.closest('#CartDrawer.hatchill-cart-v2 .hatchill-cart-progress summary');
    if (!progressSummary) return;

    var details = progressSummary.closest('details');
    var drawer = progressSummary.closest('cart-drawer');

    window.setTimeout(function () {
      publish(
        'cart_drawer_try_before_details_toggled',
        Object.assign(getCartState(drawer), {
          expanded: Boolean(details && details.open),
          eligibility_state: details && details.dataset.eligibilityState ? details.dataset.eligibilityState : ''
        })
      );
    }, 0);
  });
})();
